<!-- 加油充值记录操作 -->
<template>
  <div>
    <el-drawer :close-on-press-escape="true" :visible.sync="dataActionBox.showStatus" :with-header="false" append-to-body custom-class="drawer_box" :direction="dataActionBox.openMode" size="50%">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="formDataList" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box" v-if="scope.index == 0">
                <el-form :inline="true" label-width="100px" size="mini" :show-message="false" :model="sendDataInfo" ref="sendDataInfo" class="baseForm">
                  <!-- 主要信息 -->
                  <el-row>
                    <el-form-item :label="formOneValue.showField" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" v-if="formOneValue.isShow==1" :rules="formOneValue.isRequired == 1? [{required:  formOneValue.isChange == 1, trigger: ['blur', 'change']}] : []">

                      <!-- 加油卡 -->
                      <el-tooltip v-if="formOneValue.entityField == 'cardId'" class="item" :disabled="sendDataInfo.cardCode==null||sendDataInfo.cardCode==''?true:false || sendDataInfo.cardCode.length<=9" effect="dark"
        :content="sendDataInfo.cardCode" placement="bottom-start">
                      <el-input  v-model="sendDataInfo.cardCode" :disabled="formOneValue.isChange == 0" :maxlength="$store.state.inputLength" @keyup.enter.native="openSearch(formOneValue.searchId,'cardId')">
                        <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                      </el-input>
</el-tooltip>
                      <!-- 司机 -->
                      <el-tooltip v-else-if="formOneValue.entityField == 'driverName'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                      <el-input  v-model="sendDataInfo[formOneValue.entityField]" :disabled="formOneValue.isChange == 0" :maxlength="$store.state.inputLength" @keyup.enter.native="openSearch(formOneValue.searchId,'driverName')">
                        <el-button @click="openSearch(formOneValue.searchId, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                      </el-input>
</el-tooltip>
                      <!-- 充值时间 -->
                      <el-date-picker :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'chargeDate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker>
                      <!-- 油卡类型 -->
                      <el-input :disabled="formOneValue.isChange == 0" v-else-if="formOneValue.entityField == 'cardType'" v-model="sendDataInfo.cardName"></el-input>

                      <!-- 充值金额 -->
                      <el-input :disabled="formOneValue.isChange==0" type="number" v-else-if="formOneValue.entityField == 'chargeMoney'" v-model.number="sendDataInfo[formOneValue.entityField]" min="0" :maxlength="$store.state.inputLength" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>

                      <el-input :disabled="formOneValue.isChange==1?false:true" v-else v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                    </el-form-item>
                  </el-row>
                </el-form>
              </div>
            </template>
          </v-tabs>
        </el-card>

        <div class="foots">
          <el-button type="primary" @click="initActionBox">关闭</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==0">保存</el-button>
          <el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType==1">保存</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 检索方案弹窗 -->
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" :parentSearchData="parentSearchData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>
</template>

<script>
import SearchScheme from "../byComponents/SearchScheme.vue"

export default {
  name: "oilCardRechargeAction",
  props: [],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme
  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "新增" || "编辑",
        actionType: 0, // 0新增，1修改
      },
      showTabs: "",
      formDataList: [],
      sendDataInfo: {
        "cardId": 0,
        cardCode: '',
        "cardType": 0,
        "cardName": '',
        "chargeDate": 0,
        "chargeMoney": 0,
        "chargeReserves1": "",
        "chargeReserves2": "",
        "chargeReserves3": "",
        "chargeReserves4": "",
        "chargeReserves5": "",
        "chargeReserves6": "",
        "createTime": 0,
        "creater": '',
        "driverName": "",
        "updateTime": 0,
      },
      oilCardTypeList: [], //油卡类型
      DialogVisible: false,   //检索
      seWidth: '0',
      seId: 0,
      seTitle: "",
      searchType: '',
      parentSearchData: {}
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, type) {
      this.seId = sId
      this.searchType = type
      this.DialogVisible = true
      this.parentSearchData[type] = this.sendDataInfo[type]
      if (type == 'driverName') {   //司机
        this.parentSearchData.opmName = this.sendDataInfo.driverName
      } else if (type == 'cardId') {//卡
        this.parentSearchData.cardCode = this.sendDataInfo.cardCode
      }
    },
    //检索带回数据
    changeInputModel(val) {
      // console.log('返hui',val)
      if (val != "" || val != undefined) {
        if (this.searchType == 'driverName') {   //司机
          this.sendDataInfo.driverName = val.opmName
        } else if (this.searchType == 'cardId') {//卡
          this.sendDataInfo.cardId = val.cardId
          this.sendDataInfo.cardCode = val.cardCode
          this.sendDataInfo.cardType = val.cardType
          this.sendDataInfo.cardName = this.getOilTypeStr(val.cardType)
        }

        this.DialogVisible = false		//关闭商品检索窗口
      } else {
        this.DialogVisible = false
        this.$message({
          message: '检索失败',
          type: 'error'
        })
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },

    //保存
    async sendDataAction() {
      let flag = false
      this.$refs['sendDataInfo'].validate((valid) => {
        if (valid) { } else {
          this.$message({
            message: '请完善充值卡的必填信息',
            type: 'error'
          })
          flag = true
          return false;
        }
      })
      if (flag) return false;
      if (this.sendDataInfo.money <= 0) {
        this.$message({
          message: '请填写正确的充值金额',
          type: 'error'
        })
        return false;
      }

      // console.log('zeng', this.sendDataInfo);
      let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
      let responseData

      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.chargerecordAddMoney(sendData)
      } else {
        responseData = await this.$http.gascardUpdate(sendData)
      }
      if (responseData && responseData.status == 200) {
        this.$message({
          message: this.dataActionBox.boxTitle + '成功',
          type: 'success'
        })
        this.$parent.getDataList()
        this.init()
        this.$refs['sendDataInfo'].resetFields()
        this.dataActionBox.showStatus = false

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        })
      }
    },

    //取消新增
    initActionBox() {
      if (this.dataActionBox.actionType == 5) return this.dataActionBox.showStatus = false
      this.dataActionBox.showStatus = false
      this.init();
      this.$refs['sendDataInfo'].resetFields();
    },

    //初始化
    init() {
      for (const key in this.sendDataInfo) {
        if (key == 'chargeDate' || key == 'createTime' || key == 'updateTime') {
          this.sendDataInfo[key] = this.$moment().valueOf()
        } else {
          this.sendDataInfo[key] = ''
        }
      }
      this.sendDataInfo.chargeMoney = 0
      this.dataActionBox.actionType = 0
      this.dataActionBox.boxTitle = ''
    },

    //父级传入 获取列表
    openBox(cate, formData, oldData = "") {
      // console.log('oldData', oldData);
      this.formDataList = formData;
      this.init();
      this.dataActionBox.showStatus = true
      this.dataActionBox.actionType = cate;
      this.showTabs = formData[0].jciName;
      if (cate == 0) {
        this.dataActionBox.boxTitle = "新增充值记录";
        this.dataActionBox.openMode = "ltr";
      } else {
        this.dataActionBox.boxTitle = "修改充值记录";
        this.dataActionBox.openMode = "rtl";
        this.sendDataInfo = JSON.parse(JSON.stringify(oldData))
      }
    },
    //获取油卡类型字符
    getOilTypeStr(str) {
      let num = parseFloat(str)
      let getStr = ''
      this.oilCardTypeList.forEach((v) => {
        if (v.diId == num) {
          getStr = v.diName
          return false
        }
      })
      return getStr
    },
    //获取油卡类型
    async getOilType() {
      let responseData = await this.$http.getCateDictionariesData({
        ids: [36],
      })
      if (responseData.status == 200) {
        this.oilCardTypeList = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        })
      }
    },


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getOilType()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.baseForm .el-row {
  display: flex;
  flex-wrap: wrap;
}
</style>
